import * as t from "io-ts";

export const PermissionV = t.type({
  name: t.string,
  slug: t.string,
  level: t.number
});

export type Permission = t.TypeOf<typeof PermissionV>;
